import React from 'react';
export function PaymentRequestsShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-14902">
      <span className="sr-only" data-id="element-14903">Loading payment requests…</span>
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-14904">
        <div className="h-6 w-56 bg-gray-200 rounded" data-id="element-14905" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-14906" />
      </div>
      {/* Tabs */}
      <div className="border-b border-gray-200 pb-0" data-id="element-14907">
        <div className="flex gap-8" data-id="element-14908">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="pb-4" data-id="element-14909">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-14910" />
            </div>)}
        </div>
      </div>
      {/* Form Content */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-14911">
        <div className="space-y-6" data-id="element-14912">
          {/* Amount section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-14913">
            <div data-id="element-14914">
              <div className="h-4 w-20 bg-gray-200 rounded mb-2" data-id="element-14915" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-14916" />
            </div>
            <div data-id="element-14917">
              <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-14918" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-14919" />
            </div>
          </div>
          {/* Description */}
          <div data-id="element-14920">
            <div className="h-4 w-28 bg-gray-200 rounded mb-2" data-id="element-14921" />
            <div className="h-24 w-full bg-gray-200 rounded-md" data-id="element-14922" />
          </div>
          {/* Additional fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-14923">
            {[1, 2, 3, 4].map(i => <div key={i} data-id="element-14924">
                <div className="h-4 w-32 bg-gray-200 rounded mb-2" data-id="element-14925" />
                <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-14926" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Action bar */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 flex justify-between items-center" data-id="element-14927">
        <div className="h-4 w-96 bg-gray-200 rounded" data-id="element-14928" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-14929" />
      </div>
    </div>;
}